import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withRouter } from 'react-router';
import lodashCompact from 'lodash/fp/compact';

import {
  hasRoleAdmin,
  hasRoleAgent,
  hasRoleApartmentLocator,
} from 'common/userRoles';
import { LEAD_STATUS_LIST } from 'common/leadConstants';

import SrLink from 'client/components/SrLink/SrLink';

import branch from 'client/core/branch';
import ApartmentLocatorActions from 'client/actions/ApartmentLocator';

@withRouter
@branch({
  currentUser: ['currentUser'],
  userAgent: ['analytics', 'userAgent'],
  unseenFeedActivityCount: ['apartmentLocator', 'unseenFeedActivityCount'],
})
class SrAgentDashboardTabBar extends Component {
  static propTypes = {
    currentUser: PropTypes.object.isRequired,
    unseenFeedActivityCount: PropTypes.number,
    location: PropTypes.object.isRequired,
  }

  componentDidMount() {
    const {
      dispatch,
      currentUser,
    } = this.props;

    if (hasRoleApartmentLocator(currentUser.roles)) {
      dispatch(ApartmentLocatorActions.getUnseenFeedActivityCount, currentUser.id);
    }
  }

  render() {
    const {
      currentUser,
      unseenFeedActivityCount,
      location,
    } = this.props;
    const isAdmin = hasRoleAdmin(currentUser.roles);
    const isAgent = hasRoleAgent(currentUser.roles) || isAdmin;
    const isApartmentLocator = hasRoleApartmentLocator(currentUser.roles) || isAdmin;

    const unseenActivityDisplayStr = unseenFeedActivityCount > 100
      ? '99+'
      : unseenFeedActivityCount;

    const tourGuideTabs = [
      {
        id: 'tour',
        label: 'Tours',
        link: '/agent/tours',
      },
      {
        id: 'search',
        label: 'Search',
        link: '/address-search',
      },
      {
        id: 'map',
        label: 'Map',
        link: '/agent/map',
      },
      {
        id: 'tour-guide-profile',
        label: 'Profile',
        link: '/agent/tour-guide-profile',
      },
    ];

    const apartmentLocatorTabs = [
      {
        id: 'feed',
        label: 'Feed',
        link: '/agent/feed',
        badge: unseenFeedActivityCount > 0
          ? unseenActivityDisplayStr
          : null,
      },
      {
        id: 'leads',
        label: 'Leads',
        link: '/agent/leads',
        additionalLinks: LEAD_STATUS_LIST.map((leadStatus) => `/agent/leads/${leadStatus}`.toLowerCase()),
      },
      {
        id: 'phone',
        label: 'Phone',
        link: '/agent/call',
      },
      {
        id: 'locator-profile',
        label: 'Profile',
        link: '/agent/locator-profile',
      },
    ];

    const tabs = lodashCompact([
      ...(isAgent ? tourGuideTabs : []),
      ...(isApartmentLocator ? apartmentLocatorTabs : []),
    ]);

    const currentTabId = (
      tabs.find(
        ({ link, additionalLinks }) =>
          location.pathname === link ||
          (additionalLinks &&
            additionalLinks.includes(`${location.pathname}`.toLowerCase()))
      ) || {}
    ).id;

    return (
      <div className='tabBar'>
        <div className='tabContainer clearfix'>
          {tabs.map((tab) => {
            return (
              <SrLink
                key={tab.id}
                className={
                  classNames(
                    'tab',
                    tab.id,
                    { active: currentTabId === tab.id },
                  )}
                to={tab.link}
              >
                <span className='icon' />
                <span className='title'>{tab.label}</span>
                {tab.badge && (
                  <span className='badge'>{tab.badge}</span>
                )}
              </SrLink>
            );
          })}
        </div>
      </div>
    );
  }
}

SrAgentDashboardTabBar.displayName = 'SrAgentDashboardTabBar';

export default SrAgentDashboardTabBar;
